import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { KryptomonsService } from 'app/services/kryptomons/kryptomons.service';
import { UserService } from 'app/services/user/user.service';
import { forkJoin } from 'rxjs';

export const KryptomonsResolver: ResolveFn<any> = (route, state) => {
  let wallet = inject(UserService)._userInfoData.recordedWallet;
  return forkJoin([
    inject(KryptomonsService).getAll(wallet)
  ]);
};
